import { AddressesScreen } from '../features/account/AddressesScreen'

export function ProfileAddressesPage() {
  return <AddressesScreen />
}
